<template>
    <div class="page-content">
        <div class="page-tool-bar">
            <div class="el-btn-group" style="display: flex;align-items: center;">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="addMenu(null)">新增</el-button>
                <el-button
                    type="danger"
                    size="small"
                    icon="el-icon-delete"
                    :disabled="multipleSelection.length <= 0"
                    @click="deleteMenu(null)"
                    >删除</el-button
                >
                <!--caidan style="margin-left: 10px;"></caidan-->
            </div>

            <div class="icon-group">
                <span title="搜索" class="icon-box" @click="search">
                    <Icon color="#606266">
                        <Search />
                    </Icon>
                </span>

                <span class="icon-box" @click="refreshMenuList">
                    <Icon color="#606266">
                        <Refresh />
                    </Icon>
                </span>
            </div>
        </div>
		<!--:expand-row-keys="expands"-->
        <!-- <el-table
            :data="menuList"
            row-key="id"
            size="small"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            @selection-change="handleSelectionChange"
            :row-style="{ height: '50px' }"
            :cell-style="{ padding: '0px' }"
            height="100%"
        >
            <el-table-column align="center" type="selection" width="80"></el-table-column>
            <el-table-column align="left" prop="menuName" label="名称" width="200"></el-table-column>
            <el-table-column align="center" prop="menuIcon" label="图标" width="80">
                <template slot-scope="scope">
                    <i v-if="scope.row.menuCategory == 1" :class="scope.row.menuIcon"></i>
                    <span v-else>{{ scope.row.menuIcon }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="类型" width="80">
                <template slot-scope="scop">
                    <div>
                        <el-tag v-if="scop.row.menuType == 1">目录</el-tag>
                        <el-tag type="success" v-if="scop.row.menuType == 2">菜单</el-tag>
                        <el-tag type="info" v-if="scop.row.menuType == 3">按钮</el-tag>
                        <el-tag type="info" v-if="scop.row.menuType == 4">路由</el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="菜单功能" width="80">
                <template slot-scope="scop">
                    <div>
                        <el-tag type="success" v-if="scop.row.menuCategory == 1">系统功能</el-tag>
                        <el-tag type="danger" v-if="scop.row.menuCategory == 2">应用功能</el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="left" prop="permission" label="权限标志" width="200"> </el-table-column>
            <el-table-column align="center" prop="menuLink" label="菜单路由" width="120"> </el-table-column>
            <el-table-column align="center" label="是否显示" width="80">
                <template slot-scope="scop">
                    <div v-if="scop.row.menuType == 1 || scop.row.menuType == 2">
                        <el-switch
                            :value="true"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            v-if="scop.row.isShow == 1"
                            @change="toggleMenuIsShow(scop.row)"
                        >
                        </el-switch>
                        <el-switch
                            :value="false"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            v-if="scop.row.isShow == 0"
                            @change="toggleMenuIsShow(scop.row)"
                        >
                        </el-switch>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="序号" width="200">
                <template slot-scope="scop">
                    <el-input-number
                        v-model="scop.row.sort"
                        @change="changeSort(scop.row)"
                        size="small"
                        label=""
                        :min="1"
                        :max="5000"
                        :step="1"
                        :controls="true"
                        controls-position="both"
                    >
                    </el-input-number>
                </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作" width="300">
                <template slot-scope="scop">
                    <div class="operation">
                        <div @click="checkMenu(scop.row.id)">
                            <Icon size="16">
                                <Eye24Regular />
                            </Icon>
                            <span class="operation-label">查看</span>
                        </div>
                        <div @click="editMenu(scop.row.id)">
                            <Icon size="16">
                                <Edit24Regular />
                            </Icon>
                            <span class="operation-label">修改</span>
                        </div>
                        <div @click="deleteMenu(scop.row.id)">
                            <Icon size="16" style="color: red">
                                <Delete24Regular />
                            </Icon>
                            <span class="operation-label" style="color: red">删除</span>
                        </div>
                        <div @click="addMenu(scop.row.id)">
                            <Icon size="16">
                                <AddCircle24Regular />
                            </Icon>
                            <span class="operation-label">添加下级菜单</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table> -->
        <div class="scrollable-table-container">
            <table class="table">
                <colgroup>
                    <col style="min-width: 120px;"> <!-- 第一列固定宽度 -->
                    <col style="min-width: 80px;"> <!-- 第二列固定宽度 -->
                    <col style="min-width: 80px;">
                    <col style="min-width: 90px;">
                    <col style="min-width: 200px;">
                    <col style="min-width: 120px;">
                    <col style="min-width: 80px;">
                    <col style="min-width: 200px;">
                    <col style="min-width: 300px;">
                </colgroup>
                <thead class="table-header">
                    <tr>
                        <th>菜单名称</th>
                        <th>图标</th>
                        <th>类型</th>
                        <th>菜单功能</th>
                        <th>权限标志</th>
                        <th>菜单路由</th>
                        <th>是否显示</th>
                        <th>序号</th>
                        <th style="z-index: 8">操作</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item, index) in menuList">
                        <tr>
                            <td @click="checkednow(item)">
                                <template v-if="item.children.length>0"><i v-if="!item.checked" class="el-icon-arrow-right"></i><i v-else class="el-icon-arrow-down" ></i></template>{{ item.menuName }}
                            </td>
                            <td style="text-align: center;">
                                <i :class="item.menuIcon" />
                            </td>
                            <td style="text-align: center;">
                                <el-tag v-if="item.menuType == 1">目录</el-tag>
                                <el-tag type="success" v-if="item.menuType == 2">菜单</el-tag>
                                <el-tag type="info" v-if="item.menuType == 3">按钮</el-tag>
                                <el-tag type="info" v-if="item.menuType == 4">路由</el-tag>
                            </td>
                            <td style="text-align: center;">
                                <!-- <el-tag type="success" v-if="item.menuCategory == 1">系统功能</el-tag> -->
                                <el-tag type="danger">应用功能</el-tag>
                            </td> 
                            <td style="text-align: center;">{{ item.permission }}</td>
                            <td style="text-align: center;">{{ item.menuLink }}</td>
                            <td style="text-align: center;">
                                <el-switch
                                    :value="true"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    v-if="item.isShow == 1"
                                    @change="toggleMenuIsShow(item)"
                                >
                                </el-switch>
                                <el-switch
                                    :value="false"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    v-if="item.isShow == 0"
                                    @change="toggleMenuIsShow(item)"
                                >
                                </el-switch>
                            </td>
                            <td style="text-align: center;">
                                <el-input-number
                                    v-model="item.sort"
                                    @change="changeSort(item)"
                                    size="small"
                                    label=""
                                    :min="1"
                                    :max="5000"
                                    :step="1"
                                    :controls="true"
                                    controls-position="both"
                                >
                                </el-input-number>
                            </td>
                            <td style="text-align: center;">
                                <div class="operation">
                                    <div @click="checkMenu(item.id)">
                                        <Icon size="16">
                                            <Eye24Regular />
                                        </Icon>
                                        <span class="operation-label">查看</span>
                                    </div>
                                    <div @click="editMenu(item.id)">
                                        <Icon size="16">
                                            <Edit24Regular />
                                        </Icon>
                                        <span class="operation-label">修改</span>
                                    </div>
                                    <div @click="deleteMenu(item.id)">
                                        <Icon size="16" style="color: red">
                                            <Delete24Regular />
                                        </Icon>
                                        <span class="operation-label" style="color: red">删除</span>
                                    </div>
                                    <div @click="addMenu(item.id)">
                                        <Icon size="16">
                                            <AddCircle24Regular />
                                        </Icon>
                                        <span class="operation-label">添加下级菜单</span>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <!-- 二级 -->
                        <template  v-if="item.children.length > 0 && item.checked" v-for="(item2, index3) in item.children">
                            <tr>
                                <td @click="checkedTwo(item2)" style="align-items: center;">
                                    <div v-if="item2.children.length>0" style="display: flex;align-items: center;"><i style="text-indent: 1em" v-if="!item2.checked" class="el-icon-arrow-right"></i><i style="text-indent: 1em" v-else class="el-icon-arrow-down" ></i>{{ item2.menuName }}</div>
                                    <div style="text-indent: 2em" v-else>{{ item2.menuName }}</div>
                                </td>
                                <td style="text-align: center;">
                                    <i :class="item2.menuIcon" />
                                </td>
                                <td style="text-align: center;">
                                    <el-tag v-if="item2.menuType == 1">目录</el-tag>
                                    <el-tag type="success" v-if="item2.menuType == 2">菜单</el-tag>
                                    <el-tag type="info" v-if="item2.menuType == 3">按钮</el-tag>
                                    <el-tag type="info" v-if="item2.menuType == 4">路由</el-tag>
                                </td>
                                <td style="text-align: center;">
                                    <!-- <el-tag type="success" v-if="item2.menuCategory == 1">系统功能</el-tag> -->
                                    <el-tag type="danger">应用功能</el-tag>
                                </td> 
                                <td style="text-align: center;">{{ item2.permission }}</td>
                                <td style="text-align: center;">{{ item2.menuLink }}</td>
                                <td style="text-align: center;">
                                    <el-switch
                                        :value="true"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                        v-if="item2.isShow == 1"
                                        @change="toggleMenuIsShow(item2)"
                                    >
                                    </el-switch>
                                    <el-switch
                                        :value="false"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                        v-if="item2.isShow == 0"
                                        @change="toggleMenuIsShow(item2)"
                                    >
                                    </el-switch>
                                </td>
                                <td style="text-align: center;">
                                    <el-input-number
                                        v-model="item2.sort"
                                        @change="changeSort(item2)"
                                        size="small"
                                        label=""
                                        :min="1"
                                        :max="5000"
                                        :step="1"
                                        :controls="true"
                                        controls-position="both"
                                    >
                                    </el-input-number>
                                </td>
                                <td style="text-align: center;">
                                    <div class="operation">
                                        <div @click="checkMenu(item2.id)">
                                            <Icon size="16">
                                                <Eye24Regular />
                                            </Icon>
                                            <span class="operation-label">查看</span>
                                        </div>
                                        <div @click="editMenu(item2.id)">
                                            <Icon size="16">
                                                <Edit24Regular />
                                            </Icon>
                                            <span class="operation-label">修改</span>
                                        </div>
                                        <div @click="deleteMenu(item2.id)">
                                            <Icon size="16" style="color: red">
                                                <Delete24Regular />
                                            </Icon>
                                            <span class="operation-label" style="color: red">删除</span>
                                        </div>
                                        <div @click="addMenu(item2.id)">
                                            <Icon size="16">
                                                <AddCircle24Regular />
                                            </Icon>
                                            <span class="operation-label">添加下级菜单</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                            <!-- 三级 -->
                            <tr v-if="item2.children.length > 0 &&  item2.checked" v-for="(item3, index3) in item2.children">
                                <td style="text-indent: 3em;">{{ item3.menuName }}</td>
                                <td style="text-align: center;">
                                    <i :class="item3.menuIcon" />
                                </td>
                                <td style="text-align: center;">
                                    <el-tag v-if="item3.menuType == 1">目录</el-tag>
                                    <el-tag type="success" v-if="item3.menuType == 2">菜单</el-tag>
                                    <el-tag type="info" v-if="item3.menuType == 3">按钮</el-tag>
                                    <el-tag type="info" v-if="item3.menuType == 4">路由</el-tag>
                                </td>
                                <td style="text-align: center;">
                                    <!-- <el-tag type="success" v-if="item3.menuCategory == 1">系统功能</el-tag> -->
                                    <el-tag type="danger">应用功能</el-tag>
                                </td> 
                                <td style="text-align: center;">{{ item3.permission }}</td>
                                <td style="text-align: center;">{{ item3.menuLink }}</td>
                                <td style="text-align: center;">
                                    <el-switch
                                        :value="true"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                        v-if="item3.isShow == 1"
                                        @change="toggleMenuIsShow(item3)"
                                    >
                                    </el-switch>
                                    <el-switch
                                        :value="false"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                        v-if="item3.isShow == 0"
                                        @change="toggleMenuIsShow(item3)"
                                    >
                                    </el-switch>
                                </td>
                                <td style="text-align: center;">
                                    <el-input-number
                                        v-model="item3.sort"
                                        @change="changeSort(item3)"
                                        size="small"
                                        label=""
                                        :min="1"
                                        :max="5000"
                                        :step="1"
                                        :controls="true"
                                        controls-position="both"
                                    >
                                    </el-input-number>
                                </td>
                                <td style="text-align: center;">
                                    <div class="operation">
                                        <div @click="checkMenu(item3.id)">
                                            <Icon size="16">
                                                <Eye24Regular />
                                            </Icon>
                                            <span class="operation-label">查看</span>
                                        </div>
                                        <div @click="editMenu(item3.id)">
                                            <Icon size="16">
                                                <Edit24Regular />
                                            </Icon>
                                            <span class="operation-label">修改</span>
                                        </div>
                                        <div @click="deleteMenu(item3.id)">
                                            <Icon size="16" style="color: red">
                                                <Delete24Regular />
                                            </Icon>
                                            <span class="operation-label" style="color: red">删除</span>
                                        </div>
                                        <div @click="addMenu(item3.id)">
                                            <Icon size="16">
                                                <AddCircle24Regular />
                                            </Icon>
                                            <span class="operation-label">添加下级菜单</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </template>
                </tbody>
            </table>
        </div>
        <!-- 新增/查看/修改菜单 -->
        <el-dialog :title="menuStates[menuState] + menuTypes[menu.menuType]" :visible.sync="showDialog" width="400px" @close="closeDialog">
            <div>
                <el-form :model="menu" ref="menuForm" :rules="rules" label-width="80px" :inline="false" size="mini">
                    <el-form-item label="菜单类型">
                        <el-radio-group v-model="menu.menuType" :disabled="menuState == 'check'">
                            <el-radio :label="1">目录</el-radio>
                            <el-radio :label="2">菜单</el-radio>
                            <el-radio :label="3">按钮</el-radio>
                            <!-- <el-radio :label="4">路由</el-radio> -->
                        </el-radio-group>
                    </el-form-item>
                    <!-- <el-form-item label="菜单功能">
                        <el-radio-group size="small" v-model="menu.menuCategory" :disabled="menuState == 'check'">
                            <el-radio :label="1">系统功能</el-radio>
                            <el-radio :label="2">应用功能</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                    <el-form-item label="上级菜单" prop="parentId">
                        <el-select v-model.lazy="menu.parentId" placeholder="请选择" size="small" clearable :disabled="menuState == 'check'">
                            <el-tree default-expand-all :data="menuList" :props="treeProps">
                                <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                                    <el-option :label="node.label" :value="data.id"> </el-option>
                                </div>
                            </el-tree>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="目录名称" prop="menuName" v-if="menu.menuType == 1">
                        <input v-model.lazy="menu.menuName" placeholder="目录名称" class="el-input__inner" style="height: 32px;" :disabled="menuState == 'check'" />
                    </el-form-item>
                    <el-form-item label="菜单名称" prop="menuName" v-if="menu.menuType == 2">
                        <!-- <el-input v-if="menu.menuCategory != 2" v-model.lazy="menu.menuName" placeholder="菜单名称" size="small" :disabled="menuState == 'check'"></el-input> -->
                        <GridSelectLi title="选择菜单" labelName="menuName" labelValue="id"
                            :value="id" :limit="1" size="small"
                            :disabled="menuState == 'check'" @getValue="getValueShopId"
                            :columns="APPMEUN_code" :searchs="APPMEUN_search" dataListUrl="/mpp/appmenu/findList" entityBeanName="mppAppMenu" queryEntityUrl="/mpp/appmenu/get">
                        </GridSelectLi>
                    </el-form-item>
                    <el-form-item label="按钮名称" prop="menuName" v-if="menu.menuType == 3">
                        <el-input v-model.lazy="menu.menuName" placeholder="按钮名称" size="small" :disabled="menuState == 'check'"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="路由名称" prop="menuName" v-if="menu.menuType == 4">
                        <el-input v-model="menu.menuName" placeholder="路由名称" size="small" :disabled="menuState == 'check'"></el-input>
                    </el-form-item> -->
                    <el-form-item label="链接地址" v-if="menu.menuType != 1">
                        <el-input
                            :placeholder="menuState == 'add' ? '' : '请填写路由路径或者超链接'"
                            v-model.lazy="menu.menuLink"
                            size="small"
                            :disabled="menuState == 'check'"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="链接类型" v-if="menu.menuType != 1">
                        <el-select
                            v-model.lazy="menu.linkType"
                            placeholder="如果是路由路径请选择内部链接，http链接请选择外部链接"
                            size="small"
                            :disabled="menuState == 'check'"
                        >
                            <el-option label="内部链接" :value="1"> </el-option>
                            <el-option label="外部链接" :value="2"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="菜单图标" v-if="menu.menuType == 1 || menu.menuType == 2">
                        <!-- <el-input
                            v-model="menu.menuIcon"
                            placeholder="菜单图标名称"
                            size="small"
                            :disabled="menuState == 'check'"
                        ></el-input> -->
                        <!-- <e-icon-picker v-if="menu.menuCategory == 1" v-model.lazy="menu.menuIcon" clearable :disabled="menuState == 'check'" /> -->
                        <el-input v-model.lazy="menu.menuIcon" placeholder="请填写图标" size="small" :disabled="menuState == 'check'"></el-input>
                    </el-form-item>
                    <el-form-item label="可见" v-if="menu.menuType == 1 || menu.menuType == 2">
                        <el-radio-group v-model="menu.isShow" :disabled="menuState == 'check'">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="授权标识" v-if="menu.menuType == 2 || menu.menuType == 3">
                        <el-input
                            v-model.lazy="menu.permission"
                            placeholder="多个逗号分隔，如：user:list,user:create"
                            size="small"
                            :disabled="menuState == 'check'"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="字体颜色">
                        <el-color-picker v-model.lazy="menu.menuColor"></el-color-picker>
                    </el-form-item>
                    <el-form-item label="序号">
                        <el-input-number
                            v-model="menu.sort"
                            size="mini"
                            label=""
                            :disabled="menuState == 'check'"
                            :min="1"
                            :max="5000"
                            :step="1"
                            :controls="true"
                            controls-position="both"
                        >
                        </el-input-number>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input
                            type="textarea"
                            placeholder="备注"
                            :rows="2"
                            v-model="menu.remarks"
                            size="small"
                            :disabled="menuState == 'check'"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="flex justify-end">
                <el-button @click="closeDialog">关闭</el-button>
                <el-button type="primary" @click="submitForm" v-if="menuState != 'check'">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { GridDots, ArrowDown, Refresh, Printer, Search } from '@v2icons/tabler';
import { getMenuList, getMenuById, addMenu, deleteMenu, editMenu } from '@/api/menu.js';
import { Edit24Regular, Delete24Regular, AddCircle24Regular, Eye24Regular } from '@v2icons/fluent';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { APPMENU, APPMENU_SEARCH } from '@/utils/constant.js'
import caidan from '@/components/system/caidan.vue'
export default {
    components: {
        GridDots,
        ArrowDown,
        Refresh,
        Printer,
        Edit24Regular,
        Delete24Regular,
        AddCircle24Regular,
        Eye24Regular,
        Search,
        GridSelectLi,
        caidan
    },
    props: {
        screen:{
            type: Number,
            default:1
        }
    },
    computed: {
        selectMenuList() {
            return [
                {
                    menuName: '功能菜单',
                    parentId: null,
                    children: [...this.menuList]
                }
            ];
        }
    },
    data() {
        return {
            APPMEUN_code: APPMENU,
            APPMEUN_search: APPMENU_SEARCH,
            multipleSelection: [],
            menuList: [],
            isSearch: false,
            menuState: 'add',
            menuStates: {
                add: '新增',
                check: '查看',
                edit: '编辑'
            },
            menuTypes: {
                1: '目录',
                2: '菜单',
                3: '按钮',
                4: '路由'
            },
            showDialog: false,
            menu: {
                parentId: null,
                isShow: 1,
                menuIcon: '',
                menuName: '',
                menuType: 2,
                menuLink: '',
                permission: '',
                linkType: null,
                sort: 1,
                remarks: '',
                menuColor: null,
                menuCategory: 2,
            },
            id: '',
            rules: {
                // parentId: [{ required: true, message: '上级菜单不能为空', trigger: 'blur' }],
                menuName: [{ required: true, message: '菜单名称不能为空', trigger: 'blur' }]
            },
            currentMenuId: '',
            treeProps: {
                children: 'children',
                label: 'menuName'
            },
            expands: []
        };
    },
    created() {
        this.getMenuList();
    },
    methods: {
        checkednow(val){
            console.log(val,'我存在')
            for (const iterator of this.menuList) {
                if(iterator.id == val.id){
                    iterator.checked = !iterator.checked
                    break;
                }
            }
        },
        checkedTwo(val){
            for (const iterator of this.menuList) {
                for (const iterator1 of iterator.children) {
                    if(iterator1.id == val.id){
                        iterator1.checked = !iterator1.checked
                        break;
                    }
                }
            }
        },
        getID(){
            get(`/mpp/appmenu/findList`,{ menuName: this.menu.menuName, pageNum: 1, pageSize: 10  }).then((res) => {
                if (res.success) {
                    console.log(res.page.list[0].id);
                    this.id = res.page.list[0].id
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getValueShopId(val){
            get(`/mpp/appmenu/get`,{ id: val }).then((res) =>{
                    if(res.success){
                      console.log(res.mppAppMenu);
                      this.id = res.mppAppMenu.id;
                      this.menu.menuName = res.mppAppMenu.menuName;
                      this.menu.menuLink = res.mppAppMenu.menuLink;
                      this.menu.menuIcon = res.mppAppMenu.menuIcon;
                      this.menu.linkType = 1;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
        },
        search() {
            this.isSearch = !this.isSearch;
            this.$emit('send', this.isSearch);
        },
        ...mapActions(['getLeftMenuList']),
        resetMenuList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.menuList = [];
        },
        resetDialog() {
            this.menuState = 'add';
            this.showDialog = false;
            this.menu = {
                parentId: null,
                isShow: 1,
                menuIcon: '',
                menuName: '',
                menuType: 2,
                menuLink: '',
                permission: '',
                linkType: null,
                sort: 1,
                remarks: '',
                menuColor: null,
                menuCategory: 2
            };
            this.id = ''
            this.$nextTick(function () {
                // console.log(this.$refs.menuForm)
                // this.$refs.menuForm.resetFields();
            });
        },
        closeDialog() {
            this.resetDialog();
        },
        changeSort(menu) {
            console.log(menu);
            if (!menu.parentId) {
                delete menu.parentId;
            }
            delete menu.children;
            editMenu({ ...menu }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: `编辑${this.menuTypes[this.menu.menuType]}成功`,
                        type: 'success',
                        duration: 2000
                    });
                    this.getLeftMenuList();
                    this.resetDialog();
                    this.resetMenuList();
                    this.getMenuList();
                }
            });
        },
        submitForm() {
            if (this.menuState == 'add') {
                this.$refs.menuForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        const menu = {
                            ...this.menu
                        };
                        if (!menu.parentId) {
                            delete menu.parentId;
                        }
                        addMenu({ ...menu }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: `新增${this.menuTypes[this.menu.menuType]}成功`,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.getLeftMenuList();
                                this.resetDialog();
                                this.resetMenuList();
                                this.getMenuList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.menuState == 'edit') {
                this.$refs.menuForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        const menu = {
                            ...this.menu
                        };
                        if (!menu.parentId) {
                            delete menu.parentId;
                        }
                        delete menu.children;
                        editMenu({ ...menu }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: `编辑${this.menuTypes[this.menu.menuType]}成功`,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.getLeftMenuList();
                                this.resetDialog();
                                this.resetMenuList();
                                this.getMenuList();
                            }
                        });
                    }
                });
            }
        },
        toggleMenuIsShow(menu) {
            if (!menu.parentId) {
                delete menu.parentId;
            }
            delete menu.children;
            editMenu({ ...menu, isShow: menu.isShow == 1 ? 0 : 1 }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: `编辑${this.menuTypes[this.menu.menuType]}成功`,
                        type: 'success',
                        duration: 2000
                    });
                    // this.getLeftMenuList();
                    // this.resetDialog();
                    // this.resetMenuList();
                    // this.getMenuList();
                }
            });
        },
        addMenu(id) {
            this.menu.parentId = id;
            this.showDialog = true;
            this.menuState = 'add';
        },
        checkMenu(menuId) {
            console.log(menuId);
            this.currentMenuId = menuId;
            this.getMenuById();
            this.showDialog = true;
            this.menuState = 'check';
        },
        editMenu(menuId) {
            console.log('menu', menuId);
            if (menuId) {
                this.currentMenuId = menuId;
                this.getMenuById();
            } else {
                this.menu = { ...this.menu, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.menuState = 'edit';
        },
        deleteMenu(menuId) {
            let menuIds = '';
            if (menuId) {
                menuIds = menuId;
            } else {
                menuIds = this.multipleSelection.map((menu) => menu.id).join(',');
            }
            console.log({ menuIds });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteMenu({ menuIds }).then((res) => {
                        console.log({ res });
                        if (res.success) {
                            this.$message({
                                message: '删除菜单成功',
                                type: 'success',
                                duration: 2000
                            });
                            this.getLeftMenuList();
                            this.getLeftMenuList();
                            this.resetMenuList();
                            this.getMenuList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshMenuList() {
            this.resetMenuList();
            this.getMenuList();
        },

        getMenuList(query = {}) {
            this.loading = true;
            getMenuList({ ...query }).then((res) => {
                this.loading = false;
                if (res.success) {
                    for (const iterator of res.listMenu) {
                        for (const iterator1 of iterator.children) {
                            iterator1.checked = false;
                        }
                        iterator.checked = false;
                    }
                    this.menuList = this.filterTreeByCondition(res.listMenu,2);
                    console.log(this.menuList)
                    res.listMenu.forEach((element) => {
                        this.expands.push(element.id);
                    });
                }
            });
        },

        getMenuById() {
            getMenuById({ id: this.currentMenuId }).then((res) => {
                if (res.success) {
                    this.menu = { ...this.menu, ...res.getMenu };
                    this.getID()
                }
            });
        },
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMenuList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMenuList();
        },
        filterTreeByCondition(treeData, menuCategory) {
            return treeData.reduce((acc, node) => {
                if (node.menuCategory === menuCategory) {
                    acc.push({
                        ...node,
                        children: this.filterTreeByCondition(node.children || [], menuCategory)
                    });
                } else if (Array.isArray(node.children)) {
                    const filteredChildren = this.filterTreeByCondition(node.children, menuCategory);
                    if (filteredChildren.length > 0) {
                        acc.push({
                        ...node,
                        children: filteredChildren
                        });
                    }
                }
                return acc;
            }, []);
        }
    }
};
</script>

<style lang="scss" scoped>
.scrollable-table-container {
    width: 100%;
    height: calc(100vh - 124px);
    overflow-y: auto;
    margin-top: 10px;
    overflow-x: auto;
}

th {
    background-color: #f2f2f2 !important; /* 可以设置表头背景颜色 */
    position: sticky;
    top: 0;
    z-index: 8;
    text-align: center;
}

table {
    min-width: 1400px;
    border-collapse: collapse;
    font-size: 12px;
    font-family: inherit;
    line-height: inherit;
    border-spacing: 0;
    table-layout: fixed;
}
tr{
    border-bottom: 1px solid #f4f4f4;
}
td {
    padding: 10px 8px;
    color: #606266;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
th {
    // border-bottom: 1px solid #f4f4f4;
    padding: 8px 10px;
    color: #606266;
}
table td:last-child,table th:last-child{
    position: sticky;
    z-index: 6;
    background-color: #fff;
    border-bottom: 1px solid #f4f4f4;
    right: 0;
}
table td:last-child::after,table th:last-child::after{
    content: '';
    width: 3px;
    height: 100%;
    z-index: 2;
    box-shadow: -1px 0px 10px rgba(0, 0, 0, 0.05), -4px 0px 5px rgba(0, 0, 0, 0.08), -2px 0px 4px -1px rgba(0, 0, 0, 0.12);
    position: absolute;
    top: 0;
    left: 0px;
}
table td:first-child{
    cursor: pointer;
}
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.el-select {
    width: 100%;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
